import React from 'react'

function Footer() {
  return (
    <p style={{padding:"20px",backgroundColor:"black",textAlign:"center",fontSize:"13px"}}>
    Copy right &copy; 2022 Crypto Tracker - Developed by Jasir
   </p>
  )
}

export default Footer